import { Handle, Position } from "reactflow";
import * as Icons from "lucide-react";
import { X } from "lucide-react";
import { ELEMENT_TYPES, LAYER_COLORS, STATUS_COLORS } from "@/constants/archimate";

const HANDLE_STYLE = { width: 8, height: 8, background: "#475569", border: "1px solid white" };

export function ArchiNode({ id, data, selected }) {
  const { element, onClick, onRemove, readOnly } = data;
  const typeInfo = ELEMENT_TYPES[element.type] || {};
  const colors = LAYER_COLORS[element.layer] || LAYER_COLORS.business;
  const Icon = Icons[typeInfo.icon] || Icons.Box;
  const statusColor = STATUS_COLORS[element.status] || STATUS_COLORS.Dev;

  return (
    <div
      data-testid={`archimate-node-${element.type}-${element.id}`}
      onClick={readOnly ? () => onClick(element.id) : undefined}
      onDoubleClick={readOnly ? undefined : () => onClick(element.id)}
      title={readOnly ? "Tap to view details" : "Double-click to view details"}
      className={`group relative h-full w-full rounded-md border-2 shadow-sm hover:shadow-lg transition-shadow cursor-pointer ${selected ? "ring-2 ring-offset-1 ring-blue-500" : ""}`}
      style={{ background: colors.bg, borderColor: colors.border }}
    >
      <Handle id="top" type="target" position={Position.Top} style={HANDLE_STYLE} />
      <Handle id="left" type="target" position={Position.Left} style={HANDLE_STYLE} />
      <Handle id="right" type="source" position={Position.Right} style={HANDLE_STYLE} />
      <Handle id="bottom" type="source" position={Position.Bottom} style={HANDLE_STYLE} />
      <div className="h-full w-full rounded-md overflow-hidden">
        <span
          data-testid={`status-dot-${element.id}`}
          title={`Status: ${statusColor.label}`}
          className="nodrag absolute top-1 right-1 h-2.5 w-2.5 rounded-full border border-white shadow-sm z-10"
          style={{ background: statusColor.dot }}
        />
        <div className="flex items-center gap-1.5 px-2 py-1 border-b" style={{ borderColor: colors.border, background: "rgba(255,255,255,0.4)" }}>
          <Icon size={12} style={{ color: colors.text }} />
          <span className="text-[9px] font-semibold uppercase tracking-wide truncate" style={{ color: colors.text }}>
            {typeInfo.label || element.type}
          </span>
        </div>
        <div className="px-2 py-1.5 text-xs font-semibold leading-snug" style={{ color: colors.text }}>
          {element.name}
        </div>
      </div>
      {!readOnly && (
        <button
          data-testid={`remove-node-button-${id}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(id);
          }}
          className="absolute top-5 right-1 opacity-0 group-hover:opacity-100 transition-opacity rounded-full bg-white/80 hover:bg-white p-0.5"
        >
          <X size={11} style={{ color: colors.text }} />
        </button>
      )}
    </div>
  );
}
